/* src/app/core/widgets/dvla-reg/dvla-reg.component.scss */
/*# sourceMappingURL=dvla-reg.component.css.map */
